import { TransportIncidentService } from '../../services/transport-incident.service';
import { TransportIncidentExtendedService } from '../../services/transport-incident-extended.service';
import { AcceptanceExtendedService } from '../../services/acceptance-extended.service';
import { AcceptanceService } from '../../services/acceptance.service';
import { BaryCutoffExtendedService } from '../../services/bary-cutoff-extended.service';
import { TransporterConfigurationExtendedService } from '../../services/transporter-configuration-extended.service';
import { TaskService } from '../../services/task.service';
import { TaskExtendedService } from '../../services/task-extended.service';
import { TransportOrderItemExtendedService } from '../../services/transport-order-item-extended.service';
import { TransportOrderItemService } from '../../services/transport-order-item.service';
import { SpecialPlaceService } from '../../services/special-place.service';
import { SpecialPlaceExtendedService } from '../../services/special-place-extended.service';
import { TransportIncidentItemService } from '../../services/transport-incident-item.service';
import { TransportIncidentItemExtendedService } from '../../services/transport-incident-item.extended.service';
import { SpecialPlacePricingItemService } from '../../services/special-place-pricing-item.service';
import { SpecialPlacePricingItemExtendedService } from '../../services/special-place-pricing-item-extended.service';
import { OfferHandlingTypeService } from '../../services/offer-handling-type.service';
import { OfferHandlingTypeExtendedService } from '../../services/offer-handling-type-extended.service';
import { TransportExtendedService } from '../../services/transport-extended.service';
import { TransportService } from '../../services/transport.service';
import { TransportOrderService } from '../../services/transport-order.service';
import { TransportOrderExtendedService } from '../../services/transport-order-extended.service';
import { BasketOrderService } from '../../services/basket-order.service';
import { BasketOrderExtendedService } from '../../services/basket-order-extended.service';
import { RefAdrService } from '../../services/ref-adr.service';
import { RefAdrExtendedService } from '../../services/ref-adr-extended.service';
import { TransporterConfigurationService } from '../../services/transporter-configuration.service';
import { BaryCutOffService } from '../../services/bary-cutoff.service';

export const serviceProviders = [
  {
    provide: TransportIncidentService,
    useClass: TransportIncidentExtendedService,
  },
  {
    provide: AcceptanceService,
    useClass: AcceptanceExtendedService,
  },
  {
    provide: BaryCutOffService,
    useClass: BaryCutoffExtendedService,
  },
  {
    provide: TransportOrderService,
    useClass: TransportOrderExtendedService,
  },
  {
    provide: TransporterConfigurationService,
    useClass: TransporterConfigurationExtendedService,
  },
  {
    provide: TaskService,
    useClass: TaskExtendedService,
  },
  {
    provide: TransportOrderItemService,
    useClass: TransportOrderItemExtendedService,
  },
  {
    provide: SpecialPlaceService,
    useClass: SpecialPlaceExtendedService,
  },
  {
    provide: TransportIncidentItemService,
    useClass: TransportIncidentItemExtendedService,
  },
  {
    provide: SpecialPlacePricingItemService,
    useClass: SpecialPlacePricingItemExtendedService,
  },
  {
    provide: OfferHandlingTypeService,
    useClass: OfferHandlingTypeExtendedService,
  },
  {
    provide: TransportService,
    useClass: TransportExtendedService,
  },
  {
    provide: BasketOrderService,
    useClass: BasketOrderExtendedService,
  },
  {
    provide: RefAdrService,
    useClass: RefAdrExtendedService,
  },
];
